<template>
    <v-card elevation="0" style="overflow: hidden; border-radius: 8px">
        <v-card-title class="font14 py-1 greyText font-weight-regular">
            <v-icon>mdi-clipboard-clock-outline</v-icon>
            {{ $t('eventStats.openOrders') }}
        </v-card-title>
        <v-card-text class="py-0 pt-3" style="overflow: auto" :style="'max-height: ' + tableHeight + 'px; min-height: ' + tableMinHeight + 'px'">
            <v-row v-for="(item, index) in orders" :key="index" class="px-1" style="height: 66px">
                <v-card width="100%" class="my-1" elevation="1" :style="$vuetify.theme.dark ? 'background-color: #323338!important' : ''">
                    <v-card-text class="pl-2 py-2 font12">
                        <v-row class="pt-1 pl-7">
                            <v-spacer></v-spacer>
                            {{ item.created_at | formatInTimeZone('dd MMM HH:mm:ss', true) }}
                        </v-row>
                        <v-row :class="$vuetify.theme.dark ? 'whiteText' : 'black--text'">
                            <v-col style="min-width: 75px; max-width: 75px" class="text-center pl-2 pr-0 pt-0 pb-2">
                                <span v-if="item.status_id === $const.ORDER_STATUS_OPEN_ID && item.diffSec > 0" class="orangeText">
                                    <AppCountDown :fromTime="item.created_at" :timeout="item.timeout" v-model="item.diffSec"></AppCountDown>
                                    <v-btn
                                        tag="a"
                                        v-if="item.diffSec"
                                        dark
                                        color="red"
                                        @click="showCloseOrderForm(item)"
                                        style="font-size: 10px; height: 15px; padding: 0 4px; width: 65px; letter-spacing: 0"
                                    >
                                        {{ $t('action.cancel') }}
                                    </v-btn>
                                </span>
                                <span v-else-if="item.status_id === $const.ORDER_STATUS_OPEN_ID && item.timeout === null" class="orangeText">
                                    <span>{{ $t('panel.kickOff') }}</span>
                                    <br />
                                    <v-btn
                                        tag="a"
                                        dark
                                        color="red"
                                        @click="showCloseOrderForm(item)"
                                        style="font-size: 10px; height: 15px; padding: 0 4px; width: 65px; letter-spacing: 0"
                                    >
                                        {{ $t('action.cancel') }}
                                    </v-btn>
                                </span>
                                <span v-else class="font10 redText">
                                    {{ $t('panel.closing') }}
                                </span>
                            </v-col>
                            <v-col class="pl-1 pr-0 pt-0 pb-2">
                                <div class="pr-1" v-html="utils.getOrderName(item, true, false)"></div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-card-text>
        <AppDialogClose
            ref="orderClose"
            @deleteItem="closeOrder"
            @cancel="cancel"
            confirmButtoncolor="tbGreen"
            :confirmText="$t('order.closeOrderText')"
        ></AppDialogClose>
    </v-card>
</template>

<style scoped></style>

<script>
    import AppEventStatsRow from 'Pages/core/event/EventStatsRow.vue';
    import utils from 'Helpers/utils';
    import AppCountDown from 'Pages/core/countDown/AppCountDown.vue';
    import AppDialogClose from 'Pages/core/confirm/AppDialogConfirm.vue';

    export default {
        name: 'app-eventOrdersSidePanel',
        components: { AppDialogClose, AppCountDown, AppEventStatsRow },
        props: {
            tableHeight: {
                default: undefined,
                type: Number,
            },
            tableFullHeight: {
                default: undefined,
                type: Number,
            },
            betsTotal: {
                default: undefined,
                type: Array,
            },
            orders: {
                default: undefined,
                type: Array,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {
            isEmpty(value) {
                return _.isEmpty(value);
            },
            getGameName(item) {
                let info = utils.bettingInfoForMessage(item, true, 'float-end', true, false);
                return info.gameInfo + '<br>' + info.betInfo;
            },
            showCloseOrderForm(item) {
                this.item = item;
                // this.$refs.orderClose.confirmText = this.$t('order.closeOrderText');
                this.$refs.orderClose.open();
            },
            closeOrder(success) {
                let params = {
                    rows: [
                        {
                            id: this.item.id,
                            status_id: this.$const.ORDER_STATUS_CLOSING_ID,
                        },
                    ],
                };
                this.$store.dispatch('OrderModule/update', params).then(() => {
                    success();
                });
            },

            cancel(success) {
                success();
            },
        },
        computed: {
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            tableMinHeight() {
                let height = this.orders.length * 66 + 4; //4 - extra margin bottom

                return height > this.tableHeight ? this.tableHeight : height;
            },
        },
    };
</script>
